import './App.css';
import PhotoCaption from './components/PhotoCaption.js';
import PullQuoteText from "./components/PullQuoteText";
import styled, { css } from "styled-components";
import YouTube from 'react-youtube';
import {mediaQueries, sideMargins} from './shared/config';
import React, { useState, useEffect } from "react";
import CredsUnderLanding from './components/CredsUnderLanding'
import LandingPage from './components/LandingPage'

const Paragraph = styled.div`
  font-family: Merriweather;
  font-weight: 300;
  font-size: ${sideMargins.mobile};
  color: #FFFFFF;
  margin: 0 ${sideMargins.desktop};
  text-align: left;
  line-height: 32px;
  margin-bottom: 40px !important;
  ${mediaQueries.mobile}{
    margin: 0 ${sideMargins.mobile};
  }
  ${mediaQueries.tablet}{
    margin: 0 ${sideMargins.tablet};
  }
`

const Note = styled.div`
  font-family: Merriweather;
  font-weight: 300;
  font-size: 16px;
  color: #FFFFFF;
  margin: 0 ${sideMargins.desktop};
  text-align: center;
  line-height: 32px;
  margin-bottom: 40px !important;
  ${mediaQueries.mobile}{
    margin: 0 ${sideMargins.mobile};
  }
  ${mediaQueries.tablet}{
    margin: 0 ${sideMargins.mobile};
  }
`

const Credits = styled.div`
  font-family: Courier;
  font-size: 12px;
  color: white;
  text-align: right;
  margin: 0 ${sideMargins.desktop};
  ${mediaQueries.mobile}{
    margin: 0 ${sideMargins.mobile};
  }
  ${mediaQueries.tablet}{
    margin: 0 ${sideMargins.mobile};
  }
  margin-bottom: ${sideMargins.mobile} !important;
`

const BottomCreds = styled.div`
  font-family: Courier;
  font-size: 13px;
  color: white;
  border-top: 4px solid white;
  padding: ${sideMargins.mobile} 0 200px 0;
  margin-top: 200px !important;;
  margin: 0 ${sideMargins.desktop};
  ${mediaQueries.mobile}{
    margin: 0 ${sideMargins.mobile};
  }
  ${mediaQueries.tablet}{
    margin: 0 ${sideMargins.mobile};
  }
`

const Subheader = styled.div`
  color: white;
  font-weight: bold;
  font-family: Courier;
  font-size: 28px;
  text-transform: uppercase;
  margin: 0 ${sideMargins.desktop};
  text-align: left;
  margin-bottom: ${sideMargins.mobile} !important;
  ${mediaQueries.mobile}{
    margin: 0 ${sideMargins.mobile};
  }
  ${mediaQueries.tablet}{
    margin: 0 ${sideMargins.mobile};
  }
`

const VideoContainer = styled.div`
    width: 100%;
    display: flex;
    justify-content: center;
`

function App() {
  const  [ data, setData ] = useState({})

	useEffect(() => {
		fetch("https://kerckhoff.dailybruin.com/api/packages/flatpages/interactive.2020.tft/")
		.then(res => res.json())
		.then(res => setData(res.data['article.aml']))
  }, [])
  return (
    <div className="App">
      <LandingPage title={data.landing_text}/>
      <CredsUnderLanding> 
        By: {data.bylines}
        <br/> 
        {data.date}
      </CredsUnderLanding>
      {data.notes &&
        data.notes.map((content, index) =>
          <Note key={index}><i dangerouslySetInnerHTML={{ __html: content }}></i></Note>
        )
      }
      {data.content &&
        data.content.map((block, index) => {
          if (block.type === "paragraph") {
            return (
              <Paragraph key={index} className={index === 0 ? "subhead" : ""} dangerouslySetInnerHTML={{ __html: block.content }}/>
            )
          } else if (block.type === "image") {
            return(
              <PhotoCaption src={block.image_link} caption={block.image_credits}/>
            )
          } else if (block.type === "subheader") {
            return(
              <Subheader key={index}>{block.content}</Subheader>
            )
          } else if (block.type === "video") {
            return (
              <>
                <VideoContainer><YouTube videoId={block.video_link}/></VideoContainer>
                <Credits>{block.video_credits}</Credits>    
              </>
            )
          } else {
            return(<></>)
          }
        })
      }
      <Note>
        <i>
          If you have any further information about the student or faculty experience in FTVDM, please email us at enterprise@media.ucla.edu.
          <br/>
          <br/>
          Contributing reports by JORDAN WILSON.
        </i>
      </Note>
      <BottomCreds>
        Developed by Sarthak More. Illustrations by Bridgette Baron. Designed by Jongho Weon.
      </BottomCreds>
    </div>
  );
}

export default App;
